import { ProviderType } from "@declarations/models/ProviderType";
import initInstance from "./axios";

const api = initInstance('/provider-type');

export const ProviderTypeService = {
  list: async () => api.get<ProviderType[]>('list'),
};

export default ProviderTypeService;